import { DefaultResponseDTO } from '../../shared/constants';
import { get } from '../../shared/api';
import { HelpFAQDto } from './help.dto';

export const getFAQRequest = (): Promise<DefaultResponseDTO<HelpFAQDto[]>> => {
  return get<DefaultResponseDTO<HelpFAQDto[]>>(`/faq`);
};
